import {Loader} from "@mantine/core";

export const Loading = () => {
  return (
    <div className="flex flex-col gap-4 items-center my-24">
      <Loader size="xl"/>
    </div>
  )
}
